import { put, takeLatest, call } from 'redux-saga/effects'
import fetchFromAPI, { getDefaultAutorizedHeaders } from 'helpers/fetchFromApi'
import * as ApiRouter from 'constants/apiRouting'
import UrlHelper from 'helpers/url'
import {
  FETCH_SITE_LIST,
  SET_SITE_LIST,
  FETCH_LOCUS_LIST,
  SET_LOCUS_LIST,
} from './reducer'

function* fetchSiteList(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${ApiRouter.SITE_LIST}${UrlHelper.getPsfsQuery(
        action.payload,
      )}`,
    })
    yield put({ type: SET_SITE_LIST, siteList: response })
  } catch (error) {
    console.log('LAYOUT ERROR', error)
  }
}

function* fetchLocusList(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${ApiRouter.LOCUS_LIST}${UrlHelper.getPsfsQuery(
        action.payload,
      )}`,
    })
    yield put({ type: SET_LOCUS_LIST, locusList: response })
  } catch (error) {
    console.log('LAYOUT ERROR', error)
  }
}

function* entrySaga() {
  yield takeLatest(FETCH_SITE_LIST, fetchSiteList)
  yield takeLatest(FETCH_LOCUS_LIST, fetchLocusList)
}

export default entrySaga
